import { useState } from 'react'
import { ReactComponent as ArrowDownIcon } from '@tradera/blueprint/theme/icons2/arrow-down.svg'
import { ReactComponent as ArrowUpIcon } from '@tradera/blueprint/theme/icons2/arrow-up.svg'
import styles from './HeaderLinkDropdown.module.scss'
import classNames from 'classnames'

type HeaderLinkDropdownProps = {
  icon: React.ReactNode
  label: React.ReactNode
  className?: string
  border: boolean
  defaultExpanded?: boolean
  indent?: boolean
  children?: React.ReactNode
}

export const HeaderLinkDropdown = ({
  icon,
  label,
  className,
  border,
  defaultExpanded,
  indent,
  children,
}: HeaderLinkDropdownProps) => {
  const [expanded, setIsExpanded] = useState(defaultExpanded)

  const toggleOpen = (e: React.MouseEvent) => {
    e.stopPropagation()
    setIsExpanded((current) => !current)
  }

  return (
    <div className={border ? styles.border : ''}>
      <button
        onClick={toggleOpen}
        aria-expanded={expanded}
        className={classNames(styles.expandableButton, className)}
      >
        {icon && (
          <span className="d-flex align-items-center justify-content-center">
            {icon}
          </span>
        )}
        <span className="text-right mr-auto flex-grow">{label}</span>

        {expanded ? (
          <ArrowUpIcon className="icon" />
        ) : (
          <ArrowDownIcon className="icon" />
        )}
      </button>
      {expanded && (
        <ul
          className={classNames(styles.nestedDropdownMenu, {
            [styles.indent]: indent,
          })}
          style={{ paddingBottom: children ? '7px' : '0' }}
        >
          {children}
        </ul>
      )}
    </div>
  )
}
